module.exports = __webpack_public_path__ + "assets/img/introduceSix.a1708e9c.png";